import React, { useMemo } from "react"
import { useTheme } from "~/ui/styled"
import { ColumnFlex, CenterFlex, Text } from "~components/El"
import { Avatar } from "~widgets/avatar"
import { Message } from "~models"
import { useStores } from "~models"
import { AttachTransData, TransferStatus } from "~proto"
import { formatDate } from "~utils"
import { PopupRoot, PopupImageBackground, PopupClose } from "../components/PopupShell"

const transferBg = require("~assets/images/chat/transfer_bg.png")

interface Props {
  message: Message
  transferData: AttachTransData
  onClose: () => void
}

const TransferPopup: React.FC<Props> = ({ message, transferData, onClose }) => {
  const theme = useTheme()
  const { userStore } = useStores()
  const { attach = {}, sender = {}, receiver = {} } = message
  const transInfo = attach?.trans_info
  const isSender = sender?.id === userStore.currentUser?.id

  const StatusTitle = useMemo(() => {
    if (transferData?.status === TransferStatus.EXPIRED) {
      if (isSender) {
        return "该转账已超过24小时对方未收款，已退还到余额"
      } else {
        return "该转账已超过24小时"
      }
    } else if (transferData?.status === TransferStatus.REFUNDED) {
      if (isSender) {
        return "该转账已超过24小时对方未收款，已退还到余额"
      } else {
        return "该转账已超过24小时"
      }
    } else if (transferData?.status === TransferStatus.RECEIVED) {
      return `${receiver.name}已收款`
    } else {
      return `待${receiver.name}收款`
    }
  }, [transferData, receiver])

  const StatusDesc = useMemo(() => {
    if (transferData?.status === TransferStatus.PENDING) {
      if (isSender) {
        return "1天内对方未收款，将退还给你"
      }
      return ""
    }
    return ""
  }, [transferData, isSender])

  return (
    <PopupRoot width="100%">
      <PopupImageBackground src={transferBg} resizeMode="cover">
        <ColumnFlex width="100%" height="100%" alignItems="center">
          <CenterFlex
            width="60px"
            height="60px"
            padding="2px"
            mt="60px"
            borderRadius="30px"
            bg={theme.colors.text}
          >
            <Avatar avatar={sender?.avatar} size={56} name={sender?.name} />
          </CenterFlex>

          <Text
            mt="8px"
         
            fontSize={14}
            color={theme.colors.text}
            fontWeight="600"
            textAlign="left"
            style={{
              maxWidth:'80%',
            }}
          >
            {StatusTitle}
          </Text>
          <Text  as="div" 
            style={{ width: "auto", maxWidth: "70%", whiteSpace: "normal", wordBreak: "break-word", overflowWrap: "break-word" }}
            mt="5px" fontSize={14} color={theme.colors.secondary}>
            {transInfo?.note || ""}
          </Text>
          <Text mt="10px" fontSize={40} color={theme.colors.error} fontWeight="600">
            ¥{transferData.amount || "0"}
          </Text>
          {StatusDesc && (
            <Text mt="5px" fontSize={12} color={theme.colors.secondary}>
              {StatusDesc}
            </Text>
          )}
          <Text mt="5px" fontSize={10} color={theme.colors.secondary}>
            转账时间: {formatDate(transferData.created, "s")}
          </Text>
          {transferData.received_time && (
            <Text mt="5px" fontSize={10} color={theme.colors.secondary}>
              收款时间: {formatDate(transferData.received_time, "s")}
            </Text>
          )}
        </ColumnFlex>
      </PopupImageBackground>
      <PopupClose onClose={onClose} />
    </PopupRoot>
  )
}

export default TransferPopup
